import React, { useEffect, useState } from 'react';
import { SignJWT } from 'jose';

import { Layout } from '../styles';
import CONSTANTS from 'src/constants/common';

type MetabaseAppEmbedProps = {
  className: string;
  style?: React.CSSProperties;
  payload: { resource: { dashboard: null | number }; exp?: number };
  onFrame?: (x: boolean) => void;
  hidden?: boolean;
  titled?: boolean;
  bordered?: boolean;
};

export default function MetabaseAppEmbed({
  className,
  style = Layout.metabaseAppEmbed,
  payload,
  onFrame,
  hidden = false,
  titled = true,
  bordered = true,
}: MetabaseAppEmbedProps) {
  const [frame, setFrame] = useState<{ iframeUrl: null | string }>({ iframeUrl: null });

  const loadFrame = async () => {
    const mbSiteUrl = CONSTANTS.METABASE.URL;
    const mbSecretKey = new TextEncoder().encode(CONSTANTS.METABASE.SECRET_KEY);

    payload.exp = Math.round(Date.now() / 1000) + 10 * 60; // 10 minute expiration
    const token = await new SignJWT(payload)
      .setProtectedHeader({ alg: 'HS256' })
      .setExpirationTime('2h')
      .sign(mbSecretKey);

    const iframeUrl = `${mbSiteUrl}/embed/dashboard/${token}#bordered=${bordered}&titled=${titled}`;
    setFrame({ iframeUrl });
  };

  const handleFrameLoad = () => {
    if (onFrame) {
      onFrame(false);
    }
  };

  useEffect(() => {
    loadFrame();
  }, [payload]);

  return (
    <>
      {frame.iframeUrl && (
        <iframe
          hidden={hidden}
          src={frame.iframeUrl}
          className={className}
          onLoad={handleFrameLoad}
          style={{
            border: 'none',
            width: '100%',
            ...style,
          }}
        />
      )}
    </>
  );
}
